import type { FlagStep } from 'definitions';

/**
 * The step a plan (re)starts from, given where the rollout is now: the first step that rolls
 * out at least as much, so starting or resuming a plan never takes On away from anyone. Null
 * when the rollout is already past every step, which means the plan has nothing left to do.
 */
export function stepToStartFrom(steps: readonly FlagStep[], rolloutBp: number): number | null {
  const index = steps.findIndex((step) => step.rolloutBp >= rolloutBp);
  return index === -1 ? null : index;
}

/** "step 2 of 4", for the activity log. */
export const stepLabel = (index: number, steps: readonly FlagStep[]) => `plan step ${index + 1} of ${steps.length}`;
